/**
 * UpdateCategoryModal — modal simples para mudar categoria de template
 * já APPROVED.
 *
 * Meta NÃO permite mudar categoria de template em PENDING/REJECTED — o
 * próprio backend retorna erro nesse caso.
 */

import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { IconAlertTriangle } from '@tabler/icons-react';
import Swal from 'sweetalert2';
import WhatsAppCloudApiService from '../../../../../../WhatsAppCloudApi/services/WhatsAppCloudApiService';

const CATEGORIES = ['MARKETING', 'UTILITY', 'AUTHENTICATION'];

const UpdateCategoryModal = ({ show, onHide, template, agentId, onUpdated }) => {
  const [newCategory, setNewCategory] = useState(template?.category || 'UTILITY');
  const [saving, setSaving] = useState(false);

  if (!template) return null;

  const isApproved = template.status === 'APPROVED';

  const handleSave = async () => {
    if (newCategory === template.category) {
      Swal.fire({
        icon: 'info',
        title: 'Sem mudanças',
        text: 'Selecione uma categoria diferente da atual.',
      });
      return;
    }
    setSaving(true);
    try {
      await WhatsAppCloudApiService.updateTemplateCategory(
        agentId,
        template.template_id || template.id,
        newCategory,
      );
      Swal.fire({
        icon: 'success',
        title: 'Categoria atualizada',
        text: `${template.name} agora é ${newCategory}.`,
        timer: 2000,
        showConfirmButton: false,
      });
      if (onUpdated) onUpdated();
      onHide();
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao atualizar',
        text: err.response?.data?.error || err.message || 'Tente novamente.',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>
          Alterar categoria — {template.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isApproved && (
          <div
            style={{
              padding: 12,
              background: '#fffbeb',
              border: '1px solid #fde68a',
              borderRadius: 6,
              marginBottom: 12,
              display: 'flex',
              gap: 8,
              alignItems: 'flex-start',
              fontSize: 12,
              color: '#92400e',
            }}
          >
            <IconAlertTriangle size={16} style={{ flexShrink: 0, marginTop: 2 }} />
            <div>
              Meta só aceita mudança de categoria após aprovação. Status
              atual: <strong>{template.status}</strong>. Tentativa pode ser
              rejeitada pela Meta.
            </div>
          </div>
        )}

        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>
          Categoria atual: <strong>{template.category}</strong>
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {CATEGORIES.map((c) => (
            <label
              key={c}
              style={{
                padding: 10,
                border: '1px solid',
                borderColor: newCategory === c ? '#1877f2' : '#e5e7eb',
                borderRadius: 6,
                cursor: 'pointer',
                display: 'flex',
                gap: 8,
                background: newCategory === c ? '#eff6ff' : '#fff',
              }}
            >
              <input
                type="radio"
                name="cat"
                value={c}
                checked={newCategory === c}
                onChange={() => setNewCategory(c)}
              />
              <span style={{ fontSize: 13 }}>{c}</span>
            </label>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="tmpl-wizard__btn"
          onClick={onHide}
          disabled={saving}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="tmpl-wizard__btn tmpl-wizard__btn--primary"
          onClick={handleSave}
          disabled={saving || newCategory === template.category}
        >
          {saving ? <Spinner animation="border" size="sm" /> : 'Salvar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateCategoryModal;
